module.exports = __webpack_public_path__ + "static/media/arrow-link.815a3dae.svg";